export const USAGE_LIST = 'USAGE_LIST';
export const USAGE_ERROR = 'USAGE_ERROR';
export const USAGE_CLEAR_GRID_DATA = 'USAGE_CLEAR_GRID_DATA';
export const USAGE_LOADING = 'USAGE_LOADING';
export const PRINT_PREVIEW_USAGE_LOADING = 'PRINT_PREVIEW_USAGE_LOADING';
export const PRINT_PREVIEW_ERROR = 'PRINT_PREVIEW_ERROR';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';
export const CLEAR_USAGE_ERROR = 'CLEAR_USAGE_ERROR';
export const DELETE_SUCCESS_MESSAGE = 'DELETE_SUCCESS_MESSAGE';
export const SET_PRINT_DATA = 'SET_PRINT_DATA';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/UsageList/types.js